import keyMirror from 'keymirror-nested'

export default keyMirror({
  SELECTOR: {
    UPDATE: null,
    RESET: null,
  },
})
